// BackOffice 4Comply: aplicação separada (repositório e deploy próprios), só pra uso
// interno — a lista abaixo é intencionalmente curta (só quem já tem conta no
// BackOffice), não é "todo mundo tipo 4Comply". O controle de acesso de verdade é o
// login próprio do BackOffice; isto aqui só decide se o link/atalho aparece ou não.
const BACKOFFICE_EMAILS_PERMITIDOS = [
  'salomao.oliveira@4hc.com.br',
  'cesar.oliveira@4hc.com.br',
  'emanuel.nascimento@4hc.com.br',
];

// Em produção isso é servido no mesmo domínio, atrás do sub-caminho /backoffice (ver
// README do repo backoffice) — em dev local, usar REACT_APP_BACKOFFICE_URL=http://localhost:4201
// num .env.local pra testar contra o servidor local em vez de produção.
export const BACKOFFICE_URL = process.env.REACT_APP_BACKOFFICE_URL || 'https://4comply.com.br/backoffice';

export function podeAcessarBackoffice(email?: string | null): boolean {
  return !!email && BACKOFFICE_EMAILS_PERMITIDOS.includes(email);
}

export function usuarioLogadoEmail(): string | undefined {
  try {
    return JSON.parse(localStorage.getItem('usuarioData') || '{}').email;
  } catch {
    return undefined;
  }
}
